import script from "./Primary.vue?vue&type=script&lang=ts&setup=true"
export * from "./Primary.vue?vue&type=script&lang=ts&setup=true"

import "./Primary.vue?vue&type=style&index=0&id=c13992da&lang=css"

const __exports__ = script;

export default __exports__